import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { AddinforistorantePage } from '../../pages/addinforistorante/addinforistorante';
import { EditinfostorePage } from '../../pages/editinfostore/editinfostore';
import { SERVER_URL } from "../../config";

const URL = SERVER_URL + '/infoStore/updateInfoStoreImg';
/**
 * Generated class for the InforistorantePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-inforistorante',
  templateUrl: 'inforistorante.html',
})
export class InforistorantePage {
  info: any;
  errorMessage: string;

  link;
  constructor(public navCtrl: NavController,
    public rest: RestApiProvider,
    private readonly loadingCtrl: LoadingController,
    public navParams: NavParams) {
    this.link = SERVER_URL + "/manifesti/files/"


  }
  openEditinfostorePage(){
    console.log('openAddinforistorantePage() info:' + JSON.stringify(this.info));
    if (JSON.stringify(this.info) != "{}")
  
      this.navCtrl.push(EditinfostorePage, { info: this.info });
      else
      { alert('Informazione del ristorante non presente.') }


  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad InforistorantePage');

    console.log("infoRistorante:" + JSON.stringify(this.info));

  }
  ionViewWillEnter() {
    console.log('ionViewWillEnter InforistorantePage');

    this.getInfoRistorante();

  }
  getInfoRistorante() {
    let loading = this.loadingCtrl.create({

      spinner: 'bubbles',

      content: 'loading ...'

    });

    loading.present();
    this.rest.getInfoRistorante()
      .subscribe(
        info =>{ this.info = info;
          //alert(JSON.stringify(info))
        },
        error => this.errorMessage = <any>error);
    loading.dismiss();

    console.log("infoRistorante:" + JSON.stringify(this.info));
  }
  openAddinforistorantePage() {
    console.log('openAddinforistorantePage() info:' + JSON.stringify(this.info));
    if (JSON.stringify(this.info) != "{}") { alert('Informazione del ristorante già presente.') }
    else {
      this.navCtrl.push(AddinforistorantePage);

    }

  }
 


}



// WEBPACK FOOTER //
// ./src/pages/inforistorante/inforistorante.ts